import React from 'react';

import { Icon } from '@gitbook/spine-icons';
import { TextInput } from '@gitbook/spine-react';
import { useDebouncedState } from '@gitbook/util-react-hooks';

import { useNavigation } from '../../../navigation';
import { useIntegrationsScreen } from '../hooks';

export function IntegrationSearchInput(): React.ReactElement {
    const { navigate } = useNavigation();
    const { search: searchParam } = useIntegrationsScreen();

    const [searchInputValue, searchQuery, setSearchValue] = useDebouncedState<string>(
        searchParam || '',
        { delay: 300 }
    );

    React.useEffect(() => {
        navigate({ current: { search: searchQuery } });
    }, [searchQuery, navigate]);

    return (
        <TextInput
            size="large"
            leadingIcon={Icon.Search}
            value={searchInputValue}
            placeholder="Search for an integration..."
            onChange={(event) => {
                setSearchValue(event.target.value);
            }}
            className="mt-4 min-w-52 max-md:w-full md:flex-1"
        />
    );
}
